export default __webpack_public_path__ + "static/media/cmesmat.37895c90.png";